import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks/useAppSelector';
import { RootState } from '../../store/types/rootState';
import { Button, Grid, ListItemIcon, Menu, MenuItem, SelectChangeEvent, Skeleton, Tooltip } from '@mui/material';
import { Logout, Person } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { logoutAction } from '../../store/slices/auth';
import { saveUserAction } from '../../store/slices/user';
import { useGetAccountQuery, useGetRafflesQuery } from '../../store/api';
import { saveAccountAction } from '../../store/slices/account';
import { useAppDispatch } from '../../store/hooks/useAppDispatch';
import { PAGES } from '../../constants/pages';
import { IWinner } from '../../store/interfaces/IWinner';
import { RaffleSelector } from '../raffle/utils/raffleSelector';
import { saveSelectedRaffleAction } from '../../store/slices/selectedRaffle';
import { IRaffle } from '../../store/interfaces/IRaffle';
import { useIsMobileView } from '../../utils/responsive';
import { getPrimaryColorByAccountId } from '../../utils/styleConstants';


function Header() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();


  const isLoggedIn = useSelector(({ authentication }: RootState) => authentication.isLoggedIn);
  const profile = useSelector(({ user }: RootState) => user.profile);
  const accountInformation = useAppSelector(({ account }: RootState) => account);
  const isMobile = useIsMobileView();

  const { data: accountFounded, error: errorGetAccount, isUninitialized, isLoading, isError } = useGetAccountQuery(null, {});

  React.useEffect(() => {
    if (!errorGetAccount || isError) {
      dispatch(saveAccountAction(accountFounded));
    }
  }, [accountFounded, dispatch, errorGetAccount, isError]);

  const handleNavigationTo = (componentUrl: string) => {
    navigate(componentUrl);
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };


    const [selectedRaffleId, setSelectedRaffleId] = React.useState<string>('');
    const { data: rafflesFounded, error: errorGetRaffles } = useGetRafflesQuery(undefined, {
      skip: !isLoggedIn
    });
  
    const handleFindRaffleStatus = (selectedRaffle: IRaffle) => {
      setSelectedRaffleId(selectedRaffle.id)
      dispatch(saveSelectedRaffleAction(selectedRaffle));
    };
  

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    dispatch(
      logoutAction({
        isLoggedIn: false,
        token: "",
      })
    );

    dispatch(saveUserAction(null));

    navigate("/login");

    setAnchorEl(null);
  };

  const skeletonHeader = <Box sx={{ width: '80%' }}>
  {[1, 2].map((item) => (
    <Skeleton
      key={item}
      animation="wave"
      variant="text"
      sx={{ borderRadius: 4 }}
    />
  ))}
</Box>;

  return !isUninitialized && isLoading ? skeletonHeader : !isError ? (
      <AppBar position="static" sx={{
        height: "100%",
        background: "transparent",
        paddingBottom: 2,
      }}>
          <Grid container>

        {isLoggedIn && (<>
          {!isMobile && <Grid item xl={2} lg={2} md={2} xs={2} sm={2}>
            <Typography variant='h6' fontWeight={"bold"} color={getPrimaryColorByAccountId(accountInformation.id)} textAlign={"center"} mt={3} ml={6}>
              {accountInformation.name}
            </Typography>
          </Grid>}
          <Grid item xl={2} lg={2} md={2} xs={2} sm={2}>
          </Grid>
          <Grid item xl={4} lg={4} md={4} xs={9} sm={4} display={"flex"} justifyContent={"flex-end"}>


            {rafflesFounded && !errorGetRaffles && rafflesFounded.length > 0 && (
                  <Box mt={2.5} mr={5} width={'100%'}>
                    <RaffleSelector
                      selectedRaffleId={selectedRaffleId}
                      handleSelectRaffle={handleFindRaffleStatus}
                      rafflesFounded={rafflesFounded}
                    />
                  </Box>
                )}
            </Grid>
            </>
        )}
          </Grid>
      </AppBar>
  ) : accountFounded ? skeletonHeader : <></>;
}

export default Header;
